export enum GroupChangeType {
    Group,
    Identifier,
    Rule,
    Script,
    GroupState,
    Trend,
    TrendSeries
}